import { render, staticRenderFns } from "./TSimpleForm.vue?vue&type=template&id=3486e58c&scoped=true&"
import script from "./TSimpleForm.vue?vue&type=script&lang=js&"
export * from "./TSimpleForm.vue?vue&type=script&lang=js&"
import style0 from "./TSimpleForm.vue?vue&type=style&index=0&id=3486e58c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3486e58c",
  null
  
)

export default component.exports